<template>
    <div class="col-md-8 col-lg-6 offset-md-2 offset-lg-3">
        <div class="card">
            <div class="card-header">Підтвердіть вашу Email адресу</div>

            <div class="card-body">
                <div class="alert alert-success" v-if="isResended" role="alert">
                    Посилання для відновлення паролю надіслано на вашу пошту. Перейдіть за посиланням та вкажіть новий пароль.
                </div>

                Перш ніж продовжити, перевірте свою електрону пошту на наявність посилання для підтвердження.
                Якщо Ви не отримали листа, <button @click.prevent="resend" class="btn btn-link p-0 m-0 align-baseline">натисніть тут для відправки нового</button>.
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import {mapActions, mapGetters} from "vuex";

export default defineComponent({
    name: 'VerificationVerify',

    data() {
        return {
            isResended: false,
        };
    },

    computed: {
        ...mapGetters({
            userToken: "user/token",
        }),

        shouldResend: function (): boolean {
            return this.$route.hash == "#resend";
        },

        isConfirming: function (): boolean {
            return this.$route.name == "verification.confirm" || this.$route.name == "email.confirm";
        },

        verificationId: function (): string {
            return this.$route.params.id as string;
        },

        verificationHash: function (): string {
            return this.$route.params.hash as string;
        },

        verificationQuery: function (): {} {
            return this.$route.query;
        }
    },

    mounted() {
        if(this.isConfirming) {
            this.verify();
        }

        if(this.shouldResend) {
            this.resend();
        }
    },

    methods: {
        ...mapActions({
            resendVerification: "user/resendVerification",
            verifyVerification: "user/verifyVerification",

            fetchUser: "user/fetchUser",

            errorAlert: "alerts/error",
            successAlert: "alerts/success",
        }),

        verify() {
            this.verifyVerification({
                id: this.verificationId,
                hash: this.verificationHash,
                query: this.verificationQuery
            })
                .then(() => {
                    this.fetchUser({token: this.userToken})
                        .then(() => {
                            this.$router.push('/');

                            this.successAlert({
                                message: "Ваша Email адреса успішно підтверджена",
                            });
                        });
                })
                .catch(() => {
                    this.errorAlert({
                        message: "Під час підтвердження виникла помилка, зверніться в підтримку",
                    });
                });
        },

        resend() {
            this.resendVerification()
                .then((verified: boolean) => {
                    if(verified) {
                        this.fetchUser({token: this.userToken})

                        this.$router.push('/');
                    }

                    this.isResended = true;
                })
                .catch(() => {
                    this.errorAlert({
                        message: "Під час надсилання повідомлення виникла помилка",
                    });
                });
        },
    }
});
</script>

<style scoped>

</style>